module.exports = __webpack_public_path__ + "static/speechbubble-457ea581e9bfa1c3527e761fd80714b7.png";